module.exports = __webpack_public_path__ + "media/48/e-add-c01e69a8.svg";